<template>
  <v-dialog v-model="internalDialog" max-width="600">
    <v-card>
      <v-card-title>
        <v-icon left>mdi-palette</v-icon>
        Wybierz motyw
      </v-card-title>

      <v-card-text>
        <v-list class="surface">
          <v-list-item
            v-for="theme in themesList"
            :key="theme.key"
            @click="selectTheme(theme.key)"
            :class="{ 'v-list-item--active': currentTheme === theme.key }"
          >
            <v-list-item-avatar>
              <v-icon v-if="currentTheme === theme.key" color="primary">
                mdi-check-circle
              </v-icon>
              <v-icon v-else>mdi-circle-outline</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ theme.name }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <div class="theme-preview">
                <div
                  class="theme-color"
                  :style="{ backgroundColor: getThemeColor(theme.key, 'primary') }"
                ></div>
                <div
                  class="theme-color"
                  :style="{ backgroundColor: getThemeColor(theme.key, 'secondary') }"
                ></div>
                <div
                  class="theme-color"
                  :style="{ backgroundColor: getThemeColor(theme.key, 'accent') }"
                ></div>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">Zamknij</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getThemesList, getTheme } from '@/plugins/themes'
import { sync } from 'vuex-pathify'

export default {
  name: 'ThemeSelector',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
  }),
  computed: {
    ...sync('user', ['themeKey']),
    internalDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    currentTheme: {
      get() {
        return this.themeKey
      },
      set(value) {
        this.themeKey = value
      }
    },
    themesList() {
      return getThemesList()
    }
  },
  methods: {
    selectTheme(themeKey) {
      this.currentTheme = themeKey
      this.applyTheme(themeKey)
      this.internalDialog = false
    },
    getThemeColor(themeKey, colorKey) {
      const theme = getTheme(themeKey)
      const mode = this.$vuetify.theme.dark ? 'dark' : 'light'
      return theme[mode][colorKey]
    },
    applyTheme(themeKey) {
      const themeObj = getTheme(themeKey)

      // Apply both light and dark variants into Vuetify's theme object
      if (themeObj.light) {
        // replace or merge the light theme object so Vuetify's reactivity picks it up
        this.$vuetify.theme.themes.light = Object.assign({}, this.$vuetify.theme.themes.light || {}, themeObj.light)
      }
      if (themeObj.dark) {
        this.$vuetify.theme.themes.dark = Object.assign({}, this.$vuetify.theme.themes.dark || {}, themeObj.dark)
      }

      // Keep app background/surface CSS variables for non-Vuetify places
      const activeMode = this.$vuetify.theme.dark ? 'dark' : 'light'
      const activeColors = themeObj[activeMode] || themeObj.light || {}
      if (activeColors.background) document.documentElement.style.setProperty('--app-background', activeColors.background)
      if (activeColors.surface) document.documentElement.style.setProperty('--app-surface', activeColors.surface)

      // No runtime shade generation here — rely on Vuetify's customProperties for native variables
    },

  },
  watch: {
    '$vuetify.theme.dark'() {
      // Reapply theme when switching between light/dark mode
      this.applyTheme(this.currentTheme)
    }
  },
  mounted() {
    // Apply saved theme on mount
    this.applyTheme(this.currentTheme)
  }
}
</script>

<style scoped>
.theme-preview {
  display: flex;
  gap: 4px;
}

.theme-color {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.theme-selector-activator {
  transition: background-color 0.2s ease;
  padding: 8px 0;
  border-radius: 4px;
}

.theme-selector-activator:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.theme--dark .theme-selector-activator:hover {
  background-color: rgba(255, 255, 255, 0.08);
}
</style>
